import StaleBadge from "./StaleBadge";

export interface StaleBannerProps {
  message: string;
  generatedAt: string;
}

export default function StaleBanner({ message, generatedAt }: StaleBannerProps) {
  return (
    <div
      role="status"
      className="flex w-full items-center gap-2 border-b border-yellow-200 bg-yellow-50 px-4 py-2 text-body-medium text-yellow-900"
    >
      <span aria-hidden className="shrink-0">
        ⚠
      </span>
      <span>{message}</span>
      <StaleBadge generatedAt={generatedAt} />
    </div>
  );
}
